export default {
  online: 'Online',
  in_store: 'In-store',
}
